/** * 模块名称: Machine.vue - 会议机 * 模块说明: * 创建时间: 2022-02-15 11:36 *
模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>大型会议记录、直播、字幕制作</h1>
          <h1>一站式解决方案</h1>
        </div>
        <!-- <img src="@/assets/yj1.png" alt="" /> -->
        <div class="div"></div>
      </div>
    </div>
    <div class="contBox">
      <!-- 产品简介 -->
      <h1>产品简介</h1>
      <p>
        小科会议速记机是一款集成小科集团的核心语音技术，专为各级政府、各级党政机关、各类大型企事业单位设计的专业会议速记设备，能够同时满足会议记录成稿、语音转写输出字幕、远程同步修改、文字文字网络直播、会议投票等需求，彻底颠覆传统手机速录机工作方式，使会议记录更轻松、更高效、更便捷、更准确。
      </p>
      <!-- 产品亮点 -->
      <h1>产品亮点</h1>
      <ul class="productList">
        <li v-for="item in list" :key="item.id">
          <img :src="item.url" alt="" />
          <span>{{ item.tit }}</span>
        </li>
      </ul>
      <!--政、企事业单位应用场景全覆盖  -->
      <h1>政、企事业单位应用场景全覆盖</h1>
      <ul class="subsystemCont">
        <li
          v-for="item in listArr"
          :key="item.id"
          @mouseenter="mshow(index)"
          @mouseleave="mhidden(index)"
        >
          <img :src="item.url" alt="" />
          <span>{{ item.tit }}</span>
          <!-- 蒙层 -->
          <div class="mask" v-show="aaaa">
            <span>{{ item.tit }}</span>
            <span>{{ item.cont }} </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { id: 1, url: require('@/assets/hyj1.png'), tit: '实时语音转写' },
        { id: 2, url: require('@/assets/hyj2.png'), tit: '实时上屏显示' },
        { id: 3, url: require('@/assets/hyj3.png'), tit: '远程修改字幕' },
        { id: 4, url: require('@/assets/hyj4.png'), tit: '实时会议投票' },
        { id: 4, url: require('@/assets/hyj5.png'), tit: '历史音频转写' },
        { id: 4, url: require('@/assets/hyj6.png'), tit: '扫码分享会议' },
        { id: 4, url: require('@/assets/hyj7.png'), tit: '实时中英文互译' },
        { id: 4, url: require('@/assets/hyj8.png'), tit: '远距离稳定传输' },
        { id: 4, url: require('@/assets/hyj9.png'), tit: '实时会议记录' }
      ],
      listArr: [
        {
          id: 1,
          url: require('@/assets/yc4.png'),
          tit: '办公会议',
          cont: '适用于各类需实时整理会议记录的场景，运用语言文字转写功能，可长时间记录，实时显示'
        },
        {
          id: 2,
          url: require('@/assets/yc4.png'),
          tit: '大型发布会',
          cont: '采用多语种多方言语音识别、语音合成等人工智能技术，保障实时转写发言人讲话内容的准确率'
        },
        {
          id: 3,
          url: require('@/assets/yc4.png'),
          tit: '课程培训',
          cont: '可远距离培训，并自动统计选择作答结果，轻松实现师生互动'
        },
        {
          id: 4,
          url: require('@/assets/yc4.png'),
          tit: '电视节目直播',
          cont: '实现实时生成字幕，实时上屏显示，准确率高，无需字幕组人员输入、校对'
        },
        {
          id: 5,
          url: require('@/assets/yc4.png'),
          tit: '庭审现场',
          cont: '实现庭审笔录自动生成、庭审笔录音频即时回听等功能，解决庭审笔录记录速度慢、不全、不准等问题'
        },
        {
          id: 6,
          url: require('@/assets/yc4.png'),
          tit: '记者会',
          cont: '实时转写发言人及记者对话内容，并生成相应记录，无需人手一支录音笔、会后整理讲话内容'
        }
      ],
      aaaa: false
    }
  },
  methods: {
    mshow() {
      this.aaaa = true
    },
    mhidden() {
      this.aaaa = false
    }
  }
}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../../assets/hyjBanner.png');
  background-size: 100% 100%;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 60%;
      color: #fff;
      // color: #000;
      text-align: left;
    }
    .div {
      width: 30%;
    }
  }
}
.contBox {
  padding: 30px;
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  p {
    text-indent: 2em;
    font-size: 20px;
    text-align: left;
  }
  .productList {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    justify-content: space-around;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 30%;
      justify-content: space-around;
      margin-bottom: 40px;
      img {
        width: 100px;
        margin-bottom: 10px;
      }
    }
  }
  .subsystemCont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 250px;
      height: 100px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-shadow: 5px 5px 5px #36b2e7;
      border: 1px solid #2e5e9e;
      position: relative;
      margin-right: 50px;
      margin-bottom: 30px;
      img {
        margin: 0 20px;
      }
      .mask {
        width: 250px;
        height: 100px;
        background-color: #02a7f0;
        color: #fff;
        opacity: 0;
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 10px;
        padding: 5px;
        span:first-child {
          font-size: 18px;
          margin-bottom: 5px;
        }
        span:last-child {
          text-align: left;
        }
      }
    }
    li:hover .mask {
      opacity: 1;
      //  transition: all 0.5s ease 0s;
    }
  }
}
</style>
